import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// VIVA-979: al cambiar de ruta el scroll se quedaba donde lo habia dejado la
// pantalla anterior, asi que la vista destino abria a media pagina: en lugar de
// su encabezado se veian las secciones intermedias, y desde el formulario de
// creacion de eventos —que es muy alto— eso se lee como si la pantalla anterior
// no se hubiera limpiado. React Router no reinicia el scroll por su cuenta, asi
// que se hace aqui, en un solo lugar para toda la aplicacion.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  // useLayoutEffect y no useEffect: el reinicio corre antes del pintado, para que
  // no se alcance a ver un cuadro de la pantalla nueva a media pagina.
  useLayoutEffect(() => {
    // En POP (atras y adelante del navegador) no se toca el scroll: ahi el
    // usuario espera regresar al punto donde estaba, por ejemplo a la mitad del
    // feed. Solo se reinicia en las navegaciones hacia adelante.
    if (navigationType === "POP") return;

    window.scrollTo(0, 0);
    // Respaldo para los casos en que el contenedor con scroll es el elemento del
    // documento y no la ventana; si no aplica, la asignacion no hace nada.
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
